/* unplugin-vue-components disabled */import script from "./productSummaryPromo.vue?vue&type=script&lang=ts&setup=true"
export * from "./productSummaryPromo.vue?vue&type=script&lang=ts&setup=true"

import "./productSummaryPromo.vue?vue&type=style&index=0&id=6071c517&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6071c517"]])

export default __exports__